export enum AGRITRACE_PREVIEW_STATUS {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  // For error handling in UI only
  ERROR = 'ERROR'
}
